import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * Scroll to a hash target (e.g. /#services) when the route changes. Without
 * this, react-router does not scroll into anchors by default.
 */
const ScrollToHash = () => {
  const { hash, pathname } = useLocation();
  useEffect(() => {
    if (!hash) {
      window.scrollTo({ top: 0 });
      return;
    }
    const id = hash.replace('#', '');
    const t = setTimeout(() => {
      const el = document.getElementById(id);
      if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }, 80);
    return () => clearTimeout(t);
  }, [hash, pathname]);
  return null;
};

export default ScrollToHash;
